import React from 'react';

import { Typography } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

interface NavItemTextProps {
  children: string;
  className?: string;
}

const useStyles = makeStyles()(theme => ({
  text: {
    color: theme.palette.common.white,
    fontSize: 12,
    fontWeight: 600,
  },
}));

export function NavItemText({ children, className }: NavItemTextProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <Typography
      noWrap
      align="center"
      className={clsx(classes.text, className)}
      component="span"
      sx={{
        width: '100%',
      }}
    >
      {children}
    </Typography>
  );
}
